"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggle = void 0;
const react_1 = __importStar(require("react"));
const FormGroup_1 = __importDefault(require("@material-ui/core/FormGroup"));
const FormControlLabel_1 = __importDefault(require("@material-ui/core/FormControlLabel"));
const Paper_1 = __importDefault(require("@material-ui/core/Paper"));
const Switch_1 = __importDefault(require("@material-ui/core/Switch"));
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const useKeyPress_1 = require("./useKeyPress");
const testIds_1 = require("./testIds");
const launchDarkly_1 = require("./launchDarkly");
const colours = {
    white: "#ffffff",
};
const panelStyles = {
    position: "fixed",
    top: 0,
    right: 0,
    width: 500,
    height: "100vh",
    overflowY: "auto",
    background: colours.white,
    zIndex: 9999,
    fontSize: "1.6rem",
    fontWeight: "normal",
    padding: 20,
};
const featureSwitchFormControlStyles = {
    padding: "10px 0",
};
const featureSwitchToggleStyles = {
    marginRight: 5,
};
const FeatureToggle = ({ featureSwitches, updateFeatureSwitchValue, featureDefaultsByEnvironment: environmentBasedDefaults, updateAllFeatureSwitches, }) => {
    const [panelOpen, togglePanelOpen] = react_1.useState(false);
    const ctx = launchDarkly_1.useFeatureSwitchContext();
    const keyPress = react_1.useCallback((event) => {
        if (event.code === "Enter" && event.ctrlKey) {
            togglePanelOpen(!panelOpen);
        }
    }, [panelOpen]);
    useKeyPress_1.useKeyPress(keyPress);
    const setFeatureSwitchesToProduction = react_1.useCallback(() => {
        updateAllFeatureSwitches(environmentBasedDefaults.production, !ctx);
        ctx?.replaceAllFeatureSwitches(environmentBasedDefaults.production);
    }, [updateAllFeatureSwitches, environmentBasedDefaults.production, ctx]);
    const setFeatureSwitchesToStaging = react_1.useCallback(() => {
        updateAllFeatureSwitches(environmentBasedDefaults.staging, !ctx);
        ctx?.replaceAllFeatureSwitches(environmentBasedDefaults.staging);
    }, [updateAllFeatureSwitches, environmentBasedDefaults.staging, ctx]);
    const setFeatureSwitchesToDev = react_1.useCallback(() => {
        updateAllFeatureSwitches(environmentBasedDefaults.dev);
        ctx?.replaceAllFeatureSwitches(environmentBasedDefaults.dev);
    }, [updateAllFeatureSwitches, environmentBasedDefaults.dev, ctx]);
    return panelOpen ? (react_1.default.createElement(Paper_1.default, { style: panelStyles },
        react_1.default.createElement("h3", null, "Features"),
        react_1.default.createElement("div", null,
            react_1.default.createElement("h4", null, "Quick Set Features"),
            react_1.default.createElement(Button_1.default, { "data-testid": testIds_1.buttons.production, onClick: setFeatureSwitchesToProduction }, "Production"),
            react_1.default.createElement(Button_1.default, { onClick: setFeatureSwitchesToStaging, "data-testid": testIds_1.buttons.staging }, "Staging"),
            react_1.default.createElement(Button_1.default, { onClick: setFeatureSwitchesToDev, "data-testid": testIds_1.buttons.dev }, "Dev")),
        react_1.default.createElement("h4", null, "Feature Values"),
        react_1.default.createElement(FormGroup_1.default, null, Object.keys(featureSwitches)
            .filter((key) => typeof featureSwitches[key] ===
            "boolean")
            .map((featureSwitchName) => (react_1.default.createElement(FormControlLabel_1.default, { style: featureSwitchFormControlStyles, "data-testid": testIds_1.featureSwitches(featureSwitchName), control: react_1.default.createElement(Switch_1.default, { style: featureSwitchToggleStyles, size: "medium", color: "primary", checked: ctx
                    ? !!ctx.featureSwitches[featureSwitchName]
                    : featureSwitches[featureSwitchName](), onChange: (event) => {
                    updateFeatureSwitchValue(featureSwitchName, event.target.checked, !ctx);
                    ctx?.setFeatureSwitchValue(featureSwitchName, event.target.checked);
                } }), label: featureSwitchName, key: featureSwitchName })))))) : null;
};
exports.FeatureToggle = FeatureToggle;
